// extracted by mini-css-extract-plugin
export var layoutContainer = "_a1-0";
export var layoutContainerNoRounding = "_a1-6";
export var layoutContainerOpen = "_a1-5";
export var layoutContainerResizing = "_a1-1";
export var mainContent = "_a1-2";
export var resizeDivider = "_a1-3";
export var slidePanel = "_a1-4";